import React from 'react';
import AppLayout from '../components/AppLayout';
import TabContainer from '../components/TabContainer';

const ViewProceedingPage: React.FC = () => {
  return (
    <>
      <AppLayout />
      <TabContainer key={1} />
    </>
  );
};

export default ViewProceedingPage;
